<template>
  <div
    class="layout-left-panel overflow-hidden group md:hover:!w-[335px] transition-all max-md:w-0"
    v-if="id"
    :class="{
      '!w-full !translate-x-0 !h-[calc(100dvh-48px)]': isOpenMenu,
    }"
  >
    <el-scrollbar view-class="h-full flex flex-col gap-y-6">
      <div class="menu-box">
        <slot name="menu">Menu</slot>
      </div>
      <div
        class="links-box group-hover:opacity-100 md:opacity-0 transition-all pl-4"
        :class="{ 'max-md:!pb-16': basket.length > 0 }"
      >
        <slot name="links">Links</slot>
      </div>
    </el-scrollbar>
  </div>
</template>

<script setup lang="ts">
  import { useUserStore } from "~/store/UserModule";
  import { useBasketStore } from "~/store/BasketModule";

  const userStore = useUserStore();
  const { id, isOpenMenu } = storeToRefs(userStore);

  const basketStore = useBasketStore();
  const { basket } = storeToRefs(basketStore);
</script>

<style scoped lang="scss">
  .layout-left-panel {
    width: 65px;
    background: #ffffff;
    height: calc(100dvh - 80px);
    overflow: hidden;
    padding: 20px 12px;
    transform: translateX(-72px);
    min-width: 72px;
    position: fixed;
    z-index: 100;
    top: 80;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .menu-box {
    flex-grow: 1;
  }
</style>
